export const SENDING_REQUEST = 'TEMPLATESFORM_SENDING_REQUEST';
export const CREATE_SUCCESS = 'TEMPLATESFORM_CREATE_SUCCESS';
export const UPDATE_SUCCESS = 'TEMPLATESFORM_UPDATE_SUCCESS';
export const FAILURE = 'TEMPLATESFORM_FAILURE';
export const RESET_FORM = 'TEMPLATESFORM_RESET_FORM';
export const SET_VALUE = 'TEMPLATESFORM_SET_VALUE';